import moment from 'moment';
import React, { Component } from 'react';
import { Datos_Empresa, development, FORMAT_NUMBER, CURRENCY } from "../../../libs/utils/Const";

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};


class Operations extends Component {

    DocTimeFormat = (docTime) => {
        let time = (docTime || '').toString();

        if (time.length > 2) {
            let position = time.length - 2;
            time = time.slice(0, position) + ":" + time.slice(position, time.length)
        } else {
            time = `00:${time}`;
        }

        return time;
    }

    render() {
        const { DocsToPrint, ReportsModel } = this.props;

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE VENTAS</strong></h5>
                            </div>
                            <div className="col-3">
                                <span className="text-left">SUCURSAL: {DocsToPrint[0].currentUser ? DocsToPrint[0].currentUser.Sucursal : 'Sin sucursal'}</span>
                                <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-6 text-left'>
                            </div>
                            <div className='col-6 text-right'>
                                <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                            </div>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left"> Vendedor </th>
                                            <th className="text-center">Fecha</th>
                                            <th className="text-left">Artículo</th>
                                            <th className="text-left">Descripción</th>
                                            <th className="text-center">Cantidad</th>
                                            <th className="text-right pr-3">Importe</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div className='col-12'>
                                {!!DocsToPrint[0].ListOperationsVendorDelivery && DocsToPrint[0].ListOperationsVendorDelivery.map((delivery, index) => {

                                    if (delivery.body) {
                                        return (
                                            <table>
                                                <thead style={{ borderBottom: "solid 1px" }}>
                                                    <tr>
                                                        <th className="text-left"> Folio: {delivery.NumAtCard} </th>
                                                        <th className="text-center"> </th>
                                                        <th className="text-left"> </th>
                                                        <th className="text-left"> </th>
                                                        <th className="text-center"> </th>
                                                        <th className="text-right pr-3"> </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!delivery.body && delivery.body.map((line, index) => {
                                                        return (
                                                            <tr style={{ fontSize: '12px' }}>
                                                                <td className="text-left">{delivery.SlpCode + ' - ' + delivery.SlpName}</td>
                                                                <td className="text-center">{moment(delivery.DocDate).utc().format('MM/DD/YYYY') + ' ' + this.DocTimeFormat(delivery.DocTime) + ' HRS'}</td>
                                                                <td className="text-left">{line.ItemCode}</td>
                                                                <td className="text-left">{line.Dscription}</td>
                                                                <td className="text-center">{parseFloat(line.Quantity).toFixed(2)}</td>
                                                                <td className="text-right pr-3">{CURRENCY + ' ' + formatNumber.new(line.PriceAfVAT * parseInt(line.Quantity))}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                    <br />
                                                    <tr style={{ borderTop: "solid 1px" }}>
                                                        <td colspan="4"></td>
                                                        <td className="text-center"><strong>Total de la venta: </strong></td>
                                                        <td className="text-right pr-3"><strong>{CURRENCY + ' ' + formatNumber.new(delivery.DocTotal)}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        );
                                    } else {
                                        return <></>;
                                    }

                                })}
                            </div>
                        </div>
                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-12'>
                                <table>
                                    <tbody>
                                        <br />
                                        <tr style={{ borderTop: "solid 1px" }}>
                                            <td colspan="5"><strong> TOTAL DE VENTAS DE VENDEDOR:</strong></td>
                                            <td className="text-right"><strong>{CURRENCY + ' ' + formatNumber.new(DocsToPrint[0].SumTotalDelivery)}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default Operations